<template>
  <div class="container">
    <div class="row">
      <div class="col-sm">
        <h1 class="my-4">GoAbout calculator</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <BundleCalculator />
      </div>
    </div>
    <Analytics />
  </div>
</template>

<script>
import Analytics from "@/components/Analytics"
import BundleCalculator from '@/components/BundleCalculator.vue'

export default {
  name: 'app',
  components: {
    Analytics,
    BundleCalculator,
  }
}
</script>
